import React from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';

// Granular Add-Case widget — admin-authored guidance card. Reads its body
// from either the widget config (`config.markdown` for one-off copy) or
// from the chosen case type's `intake_guidance` blob (when set on the
// CaseType row), so a workspace can keep guidance per-type without
// re-editing every layout.
//
// v1 renders the markdown as plain whitespace-preserving text; we don't
// pull in a full markdown parser yet (deferred — the same gap as case
// step instructions, which also render as pre-wrap plain text today).

function AddCaseGuidance({ config }) {
  const { draft } = useLayoutCtx();
  const picked = draft?.picked || null;
  const fromConfig = (config.markdown || '').trim();
  const fromType = (() => {
    if (!picked) return '';
    const v = picked.intake_guidance || picked.guidance_markdown || picked.description;
    return typeof v === 'string' ? v.trim() : '';
  })();
  const body = fromConfig || fromType;

  if (!body) {
    return (
      <div style={{ padding: '10px 12px', color: 'var(--text-tertiary)', fontSize: '12px', fontStyle: 'italic' }}>
        No guidance configured for this case type.
      </div>
    );
  }

  return (
    <div style={{
      background: 'var(--bg-tertiary)',
      border: '1px solid var(--border-color)',
      borderLeft: '3px solid var(--accent-color)',
      borderRadius: '6px',
      padding: '10px 12px',
      fontSize: '13px',
      lineHeight: 1.5,
      whiteSpace: 'pre-wrap',
      marginBottom: '8px',
    }}>
      {body}
    </div>
  );
}

registerWidget({
  type: 'add_case.guidance',
  categories: ['add_case'],
  palette_label: 'Guidance card',
  description: 'Admin-authored guidance text shown above (or beside) the intake fields. Falls back to the case type\'s description when no per-widget markdown is set.',
  Component: AddCaseGuidance,
  configSchema: {
    fields: [
      { type: 'textarea', name: 'markdown', label: 'Guidance text (overrides case-type guidance)', default: '' },
    ],
  },
  publishes: [],
  subscribes: [],
  group: 'Add Case',
});
